import React from 'react';
import ForgotPasswordPage from './ForgotPasswordPage';

const ForgotPassword = () => (
	<section className="main">
	  <ForgotPasswordPage />
	</section>
);

export default ForgotPassword;
